/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import Hidden from "@mui/material/Hidden";
import { isPhoneNumberDefault, isRequired, requiredValidator } from "../../../services/validationRules";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import Person from "../Common/Person/Person";
import Address from "../Common/Address/Address";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type LegalRepresentativeProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function LegalRepresentative({ submitProps }: LegalRepresentativeProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Persönliche Angaben
            </Typography>
          </Hidden>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12}>
              <Group
                type={"radio"}
                name={"hasLegalRepresentative"}
                question={"Haben Sie einen gesetzlichen Vertreter?"}
                modalContent={
                  <p>
                    Gesetzliche Vertreter sind zum Beispiel die Eltern für ihre minderjährigen Kinder oder ein vom Gericht bestellter Betreuer. Gemeint ist hier{" "}
                    <strong>nicht</strong> der Anwalt, den Sie beauftragt haben.
                  </p>
                }
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasLegalRepresentative === "yes" && (
              <>
                <Person path="legalRepresentative" headline="Wie heißt Ihr gesetzlicher Vertreter?" />
                <Address path="legalRepresentative.addresses[0]" headline="Wo wohnt Ihr gesetzlicher Vertreter?" />
                <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
                  <FormLegend>Wie kann man Ihren gesetzlichen Vertreter telefonisch erreichen?</FormLegend>
                </Grid>
                <Grid item xs={12}>
                  <ValidatorTextField
                    name="telephoneRepresentative"
                    label="Telefonnummer"
                    autoComplete="tel"
                    validators={[
                      {
                        validator: isRequired,
                        message: "Bitte geben Sie Ihre Telefonnummer an",
                      },
                      ...isPhoneNumberDefault,
                    ]}
                  />
                </Grid>
              </>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
